// extracted by mini-css-extract-plugin
export default {"container":"App_container__4L7Vo","content":"App_content__naSmy","error":"App_error__k-zRP","offersModal":"App_offersModal__t0zpN"};